import { useQuery } from "react-query"
import * as Data from "../repositories/repairShops/repairShops"

const KEY = "cis_useCalculatedCostTypes"
export function useCalculatedCostTypes() {
    const { data } = useQuery([KEY], () => Data.getCalculatedCostTypes())

    return { calculatedCostTypes: data?.costTypes }
}
